import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { SectionHead } from "@/components/site/ui";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ContactSection = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await axios.post(`${API}/contact`, form);
      toast.success("Messaggio inviato. Ti risponderemo presto.");
      setForm({ name: "", email: "", message: "" });
    } catch {
      toast.error("Invio non riuscito. Riprova tra poco.");
    } finally {
      setSending(false);
    }
  };

  return (
    <section id="contatti" data-testid="contact-section" className="bg-[#0B0B0B] border-t border-[#262626]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-24 lg:py-32 grid lg:grid-cols-2 gap-14">
        <div>
          <SectionHead eyebrow="CONTATTI" title={"SCRIVICI.\nTI ASCOLTIAMO."} testId="contact-eyebrow" />
          <p className="mt-6 text-[#D8C7AA]/80 leading-relaxed max-w-md">
            Hai una domanda sui percorsi o sull'App Tempio Vivo? Scrivici: ti risponderemo personalmente.
          </p>
        </div>
        <form onSubmit={submit} className="space-y-5" data-testid="contact-form">
          <input
            data-testid="contact-name-input"
            className="field"
            placeholder="Il tuo nome"
            required
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
          />
          <input
            data-testid="contact-email-input"
            className="field"
            type="email"
            placeholder="La tua email"
            required
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
          />
          <textarea
            data-testid="contact-message-input"
            className="field min-h-[140px]"
            placeholder="Il tuo messaggio"
            required
            value={form.message}
            onChange={(e) => setForm({ ...form, message: e.target.value })}
          />
          <button type="submit" disabled={sending} data-testid="contact-submit-button" className="btn btn-gold-fill disabled:opacity-60">
            {sending ? "INVIO IN CORSO…" : "INVIA IL MESSAGGIO"}
          </button>
        </form>
      </div>
    </section>
  );
};
